import React from 'react'

import { ZariContext } from '_zari/context'

import { Portlet, Table } from '_zari/core'

import { TiposTablaComunConstant, CodigosTransaccionesConstant } from 'constants/index'

import * as TablasComunesService from 'services/tablasComunes.service'

import * as Modals from './modals'

const UnicoLista = ({ match }) => {
  const __zariContext = React.useContext(ZariContext)

  const [mostrarEditarModal, setMostrarEditarModal] = React.useState(false)

  const tablaRef = React.useRef(null)
  const editarData = React.useRef({})

  const nombreTabla = React.useMemo(() => {
    return `${TiposTablaComunConstant.__dictionary[match.params.tipoTabla].nombre} (${match.params.tipoTabla})`
  }, [match.params.tipoTabla])

  const portletBreadcrumbs = React.useMemo(() => {
    return [{ name: 'Tablas Comunes', path: `/${CodigosTransaccionesConstant.TABLASCOMUNES_MAIN}` }, { name: nombreTabla }]
  }, [nombreTabla])

  const headColumns = React.useMemo(() => {
    switch (match.params.tipoTabla) {
      case TiposTablaComunConstant.PAIS:
      case TiposTablaComunConstant.DEPARTAMENTO:
      case TiposTablaComunConstant.PROVINCIA:
      case TiposTablaComunConstant.DISTRITO:
        return [{ label: 'NOMBRE' }]
      case TiposTablaComunConstant.UNIDADESMEDIDA:
        return [{ label: 'CODIGO' }, { label: 'NOMBRE' }, { label: 'VALOR SUNAT' }]
      default:
        return [{ label: 'CODIGO' }, { label: 'NOMBRE' }]
    }
  }, [match.params.tipoTabla])

  const rowBaseTemplate = React.useCallback(
    row => {
      switch (match.params.tipoTabla) {
        case TiposTablaComunConstant.PAIS:
        case TiposTablaComunConstant.DEPARTAMENTO:
        case TiposTablaComunConstant.PROVINCIA:
        case TiposTablaComunConstant.DISTRITO:
          return (
            <>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
        case TiposTablaComunConstant.UNIDADESMEDIDA:
          return (
            <>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
              <Table.Cell>{row.unidadSunat || '--'}</Table.Cell>
            </>
          )
        default:
          return (
            <>
              <Table.Cell>{row.codigo || '--'}</Table.Cell>
              <Table.Cell>{row.nombre || '--'}</Table.Cell>
            </>
          )
      }
    },
    [match.params.tipoTabla]
  )

  const clickNuevo = React.useCallback(() => {
    editarData.current = {}
    setMostrarEditarModal(true)
  }, [])

  const clickEditar = React.useCallback(
    ({ _id }) => {
      TablasComunesService.getAsEdicion(_id)
        .then(({ data }) => {
          editarData.current = {
            ...data,
            _id: _id
          }
          setMostrarEditarModal(true)
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const clickEliminar = React.useCallback(
    ({ _id }) => {
      TablasComunesService.eliminarxId(_id)
        .then(() => {
          __zariContext.snack('success', 'El registro se ha eliminado.')
          tablaRef.current.reload()
        })
        .catch(({ data: { error } }) => __zariContext.snack('error', error))
    },
    [__zariContext]
  )

  const onModalSuccess = React.useCallback(() => {
    tablaRef.current.reload()
    setMostrarEditarModal(false)
  }, [])

  return (
    <>
      <Portlet>
        <Portlet.Header title='Tablas Comunes' buttons={[{ name: 'Nuevo', onClick: clickNuevo }]} breadcrumbs={portletBreadcrumbs} />
        <Portlet.Body>
          <Table.ServerSide
            ref={tablaRef}
            useNest={true}
            url='/tablas-comunes'
            baseParams={{
              tipo: match.params.tipoTabla
            }}
            headRows={[...headColumns, { label: '' }]}
            rowTemplate={row => (
              <Table.Row key={row._id}>
                {rowBaseTemplate(row)}
                <Table.Cell>
                  <Table.Dropdown>
                    {({ handleClose }) => [
                      <Table.Dropdown.Item key='editar' handleClose={handleClose} onClick={e => clickEditar({ _id: row._id })}>
                        Editar
                      </Table.Dropdown.Item>,
                      <Table.Dropdown.Item key='eliminar' handleClose={handleClose} onClick={e => clickEliminar({ _id: row._id })}>
                        Eliminar
                      </Table.Dropdown.Item>
                    ]}
                  </Table.Dropdown>
                </Table.Cell>
              </Table.Row>
            )}
          />
        </Portlet.Body>
      </Portlet>
      {mostrarEditarModal && (
        <Modals.EditarModal
          handleClose={e => setMostrarEditarModal(false)}
          show={mostrarEditarModal}
          modalData={editarData.current}
          tipoTabla={match.params.tipoTabla}
          onSuccess={onModalSuccess}
        />
      )}
    </>
  )
}

export default UnicoLista
